import { memo } from 'react'

import { ArticleContentResponse } from '@tabeeb/contracts/microservices/swagger-article-service'

import { ArticleContentType } from '../../enums'

import PdfContent from './ArticlePdfContent'
import ArticleHtmlContent from './ArticleHtmlContent'

export interface ArticleContentProps {
  content?: ArticleContentResponse
}

const ArticleContent: React.FC<ArticleContentProps> = ({ content }) => {
  return (
    <>
      {content?.Type === ArticleContentType.Html && <ArticleHtmlContent html={content.Content} />}
      {content?.Type === ArticleContentType.Pdf && <PdfContent url={content.Content} />}
    </>
  )
}

export default memo(ArticleContent)
